import { useRef } from 'react';
import { DropDownBox } from '@apply/components';
import { ExperienceProjectType, ExperienceProjectTypeOptions } from '@apply/constants';
import {
    useExperienceBudget,
    useExperienceHomeConstructedAfterPurchase,
    useExperienceProjectTypeId,
} from '../../../../fields/ExperienceFields';
export interface ProjectTypeProps {
    experienceId: string | undefined;
    width?: string;
    required?: boolean;
    readOnly?: boolean;
}

export const ProjectType: React.FC<ProjectTypeProps> = ({ experienceId, required = false, readOnly = false }) => {
    const isFirstLoad = useRef(true);

    const label = 'Project Type ';
    const [projectType, set_projectTypeId] = useExperienceProjectTypeId(experienceId);
    const [, set_budget] = useExperienceBudget(experienceId);
    const [, set_constructedAfterClosed] = useExperienceHomeConstructedAfterPurchase(experienceId);

    // Build grouped items
    const projectTypeList = ExperienceProjectTypeOptions.map((o) => ({
        display: o.name,
        value: o.id,
    }));

    const onProjectTypeChange = (id: ExperienceProjectType) => {
        // Skip the first change triggered by initial load
        if (isFirstLoad.current) {
            isFirstLoad.current = false;

            // Only skip the first change if we actually HAVE an initial value
            if (projectType !== undefined && projectType !== null) {
                return;
            }
        }

        if (id != ExperienceProjectType.FixFlipRehab) {
            set_budget(undefined);
        }
        if (id != ExperienceProjectType.PersonalResidence) {
            set_constructedAfterClosed(undefined);
        }
        set_projectTypeId(id);
    };

    return (
        <DropDownBox
            id='experienceProjectType'
            value={projectType}
            onChange={(value) => onProjectTypeChange(value)}
            required={required}
            dataSource={projectTypeList}
            displayExpr='display'
            valueExpr='value'
            label={label}
            readOnly={readOnly}
        />
    );
};
